import { createCustomEnum } from "./customEnum";

const CompanyStatusTypes = createCustomEnum({
	ActivatedAgent: {
		value: 3,
		name: "ActivatedAgent",
		displayName: "Active agent/ partner",
	},
	InactiveAgent: {
		value: 4,
		name: "InactiveAgent",
		displayName: "Inactive agent/ partner",
	},
	ProspectiveAgent: {
		value: 2,
		name: "ProspectiveAgent",
		displayName: "Prospective agent/ partner",
	},
	TerminatedAgent: {
		value: 1,
		name: "TerminatedAgent",
		displayName: "Terminated agent/ partner",
	},
});

export default CompanyStatusTypes;
